import { Component, OnInit, Input } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import * as _ from 'lodash';
import { EmpowerModernLifeService } from 'src/services/empower-services/empower-modern-life.service';
import { EmpowerExportService } from 'src/services/empower-services/empower-export.service';
import { generateTitleDiv, NO_IMAGE, undefinedImagePath } from 'src/modules/empower-module/helper';

@Component({
  selector: 'empower-sur-rev-opper-vs-mark',
  templateUrl: './sur-rev-opper-vs-mark.component.html',
  styleUrls: ['./sur-rev-opper-vs-mark.component.scss']
})
export class EmpowerSurRevOpperVsMarkComponent implements OnInit {
  @Input() data?: any;
  _unsubscribeAll = new Subject();
  undefinedImagePath = '';

  accessoriesYearlyIncrease: number;
  devicesYearlyIncrease: number;
  partnerChartCaption: string = 'Partner Revenue Growth %';
  marketChartCaption: string = 'Market Revenue Growth %';
  totalAccRevPartner: number;
  totalAccRevMarket: number;
  totalDevRevPartner: number;
  totalDevRevMarket: number;
  innerHtml = '';
  pageComment: string;

  constructor(
    public empowerModernLifeService: EmpowerModernLifeService, private empowerExportService: EmpowerExportService,
    private spinner: NgxSpinnerService,
  ) {
  }

  ngOnInit(): void {
    this.initPageData();
  }

  initPageData() {
    if (this.data) {
      this.data = JSON.parse(this.data);

      this.innerHtml = generateTitleDiv(this.data);
      this.checkPageState(this.data.pageId);
    }
  }

  checkPageState(pageId) {
    const daxReponse = this.empowerModernLifeService.getPagesState(pageId);
    this.pageComment = this.empowerModernLifeService.getPageCommentState(pageId);
    if (daxReponse && daxReponse.length) {
      this.loadVisuals(daxReponse);
    } else {
      this.executePageDaxQuery();
    }
  }

  executePageDaxQuery() {
    const payload = {
      reportId: this.data.reportId,
      pageId: this.data.pageId,
      ...this.empowerModernLifeService.getDashboardState()
    };
    this.spinner.show();
    this.empowerModernLifeService.ExecutePageDaxQuery(payload).pipe(takeUntil(this._unsubscribeAll)).subscribe(response => {
      if (response && response.length) {
        this.getDAXReponseData(response);
      } else {
        this.emitExportEvent(true);
      }
      this.spinner.hide();
    },
      err => {
        this.undefinedImagePath = undefinedImagePath;
        this.spinner.hide();
      });
  }

  getDAXReponseData(response) {
    const daxReponse = response.map(a => {
      return {
        visualId: a.visualId,
        daxResponse: a.daxResponse ? JSON.parse(a.daxResponse) : []
      }
    });
    console.log(daxReponse);
    this.setPageState(this.data.pageId, daxReponse);
    this.loadVisuals(daxReponse);
  }

  setPageState(pageId, daxData) {
    this.empowerModernLifeService.setPagesState(pageId, daxData);
  }

  emitExportEvent(resolvedState: boolean) {
    setTimeout(() => {
      this.data && this.data.export && this.empowerExportService.setExportComponentSubject(28, resolvedState, this.data.pageIndex, this.data.pageTitle);
    }, 1000);
  }

  loadVisuals(daxData) {
    this.loadThridVisual(daxData[0]);
    this.loadForthVisual(daxData[1]);
    this.loadFifthVisual(daxData[2]);
    this.loadSixthVisual(daxData[3]);
    this.loadFirstVisual(daxData[4]);
    this.loadSecondVisual(daxData[5]);
    this.emitExportEvent(true);
  }

  loadFirstVisual(visualData) {
    this.accessoriesYearlyIncrease = _.get(visualData.daxResponse, ['0', '[Total Yearly Revenue Opportunity if you close the gap with Market Growth]'], 0);
  }

  loadSecondVisual(visualData) {
    this.devicesYearlyIncrease = _.get(visualData.daxResponse, ['0', '[Total Yearly Revenue Opportunity if you close the gap with Market Growth]'], 0);
  }

  loadThridVisual(visualData) {
    this.totalAccRevPartner = _.get(visualData.daxResponse, ['0', '[Total_Rev__]'], 0);
  }

  loadForthVisual(visualData) {
    this.totalDevRevMarket = _.get(visualData.daxResponse, ['0', '[Total_Rev__]'], 0);
  }

  loadFifthVisual(visualData) {
    this.totalDevRevPartner = _.get(visualData.daxResponse, ['0', '[Market Growth %]'], 0);
  }

  loadSixthVisual(visualData) {
    this.totalAccRevMarket = _.get(visualData.daxResponse, ['0', '[Market Growth %]'], 0);
  }

  pageCommentChange(comment) {
    this.setPageCommentState(this.data.pageId, comment);
  }

  setPageCommentState(pageId, comment) {
    this.empowerModernLifeService.setPageCommentState(pageId, comment);
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

}
